export var StackEntryFlags;
(function (StackEntryFlags) {
    StackEntryFlags[StackEntryFlags["ByValue"] = 1] = "ByValue";
    StackEntryFlags[StackEntryFlags["ByReference"] = 2] = "ByReference";
})(StackEntryFlags || (StackEntryFlags = {}));
